<template>
  <div class="uk-flex uk-flex-center uk-width-1-1">
    <main-post
      :post-image-source="currentPost.imgsrc"
      :post-alt-text="currentPost.alt"
    >
      <template v-slot:postBadge>
        {{ currentPost.badge }}
      </template>
      <template v-slot:postTitle>
        {{ currentPost.title }}
      </template>
      <template v-slot:postDate>
        {{ currentPost.date }}
      </template>
      <template v-slot:postContent>
        {{ currentPost.content }}
      </template>
    </main-post>
  </div>
</template>

<script>
import MainPost from '@/components/post-templates/MainPost.vue'
import { posts } from '@/posts.js'

export default {
  components: {
    MainPost
  },
  data () {
    return {
      allPosts: posts,
      currentPost: null,
      currentUrl: ''
    }
  },
  created () {
    this.currentUrl = this.$route.params.posturl
    this.openSelectedPost()
    this.pageCheck()
  },
  methods: {
    openSelectedPost () {
      for (var i = 0; i < this.allPosts.length; i++) {
        if (this.allPosts[i].url === this.currentUrl) {
          this.currentPost = this.allPosts[i]
        }
      }
    },
    pageCheck () {
      if (this.currentPost === null) {
        console.log('page do not exist!')
        this.$router.push('/')
      }
    }
  }
}
</script>
